import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AuthContext from "../context/AuthContext";

import auth from "../services/authServices";
import { handleFormErrors, handleFormSubmit, handleInputChange } from "../services/formServices";
import http from "../services/httpServices";
import modal from "../services/modalServices";
import page from "../services/pageServices";

import InputField from "../components/form/elements/InputField";
import InputIcon from "../components/form/elements/InputIcon";
import SigningForm from "../components/form/singingForm/SigningForm";
import LoginDataTable from "../components/ui/LoginDataTable";

import loginPicture from "../assets/telawah-assets/LoginPage.png";
import {
    isAccountCreationRequest,
    isLoggingByEmail,
    isOtpEnabled,
    loginPageColor,
    loginPageIcon,
    registerPageColor,
} from "../services/defaultSettings";
import a from "../services/analyticsServices";
import OtpComponent from "./OtpComponent";
import modal2 from "../services/modal2Services";
import ForgetPasswordComponent from "./ForgetPasswordComponent";
import Button from "../components/ui/Button";
import { useLanguage } from "../context/LanguageContext";

const Login = () => {
    const { language } = useLanguage();

    const [user, setUser] = useState({
        phone: "",
        phone_to_reset: "",
        password: "",
        new_phone: "",
        with_code: false,
        otp: "",
    });
    const content = {
        title: {
            en: "Login:",
            ar: "تسجيل الدخول :",
            de: "Anmeldung:",
        },
        description: {
            en: "Access your account by entering your phone number and password.",
            ar: "ادخل علي حسابك بإدخال رقم الهاتف و كلمة المرور المسجل بهم من قبل",
            de: "Greifen Sie auf Ihr Konto zu, indem Sie Ihre Telefonnummer und Ihr Passwort eingeben.",
        },
        fields: {
            phone: {
                en: "Phone Number",
                ar: "رقم الهاتف",
                de: "Telefonnummer",
            },
            email: {
                en: "Email",
                ar: "بريدك الإلكتروني",
                de: "E-Mail",
            },
            code: {
                en: "Enter the code",
                ar: "أدخل الكود",
                de: "Geben Sie den Code ein",
            },
            codePass: {
                en: "Enter the code again",
                ar: "اعد كتابة الكود",
                de: "Geben Sie den Code erneut ein",
            },
            password: {
                en: "Password",
                ar: "كلمة السر",
                de: "Passwort",
            },
            codeSwitch: {
                en: "Or login using a code",
                ar: "أو قم بتسجيل الدخول عن طريق الكود",
                de: "Oder melden Sie sich mit einem Code an",
            },
        },
        button: {
            login: {
                en: "Login",
                ar: "تسجيل الدخول",
                de: "Anmelden",
            },
            forgetPassword: {
                en: "Forgot your password?",
                ar: "هل نسيت كلمة المرور؟",
                de: "Passwort vergessen?",
            },
            noAccount: {
                en: "Don't have an account?",
                ar: "لا يوجد لديك حساب؟",
                de: "Sie haben kein Konto?",
            },
            createAccount: {
                en: "Create an account now!",
                ar: "انشئ حسابك الآن !",
                de: "Jetzt Konto erstellen!",
            },
        },
    };

    const [tokens, setTokens] = useState([]);
    const [isBlocked, setIsBlocked] = useState(false);
    const [blockageMessage, setBlockageMessage] = useState("");
    const [errors, setErrors] = useState({});
    const [isOtp, setisOtp] = useState(false);
    const [showChangePhone, setShowChangePhone] = useState(true);
    const [isConfirmedShowPasswordPhone, setIsConfirmedShowPasswordPhone] = useState(false);

    const [showForgetPassword, setShowForgetPassword] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const { setUser: authUser, setAccountRequest } = useContext(AuthContext);
    let inputFields = [];

    if (isLoggingByEmail) {
        inputFields = [
            ...inputFields,
            {
                id: !user.with_code ? "email" : "phone",
                placeholder: user.with_code
                    ? content.fields.code[language]
                    : content.fields.email[language],
                icon: <InputIcon icon="ic:outline-alternate-email" />,
            },
        ];
    } else {
        inputFields = [
            ...inputFields,
            {
                id: "phone",
                placeholder: user.with_code
                    ? content.fields.code[language]
                    : content.fields.phone[language],
                icon: <InputIcon icon="ant-design:phone-filled" />,
            },
        ];
    }

    inputFields = [
        ...inputFields,
        {
            id: "password",
            placeholder: user.with_code
                ? content.fields.codePass[language]
                : content.fields.password[language],
            icon: <InputIcon icon="ri:lock-password-fill" />,
        },
        {
            id: "with_code",
            placeholder: content.fields.codeSwitch[language],
            type: "switch",
            icon: <InputIcon icon="ri:lock-password-fill" />,
        },
    ];

    useEffect(() => {
        const currentTitle = page.getCurrentTitle();
        page.setTitle(content.title[language]);
        return () => {
            page.setTitle(currentTitle);
        };
    }, [language]);

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, loginUser);
    };

    const navigate = useNavigate();
    const { state } = useLocation();

    const redirect = (certainPath = false) => {
        if (certainPath) {
            navigate(certainPath);
        } else {
            if (!state) {
                navigate("/home");
            } else {
                navigate(state.prevPath);
            }
        }
    };

    const loginUser = async () => {
        try {
            await http.get("/sanctum/csrf-cookie");
            const visitorVisitId = a.getVisitorVisit();
            const toSendUser = { ...user, visitor_visit_id: visitorVisitId };
            if (isLoggingByEmail && !user.with_code) {
                toSendUser["email"] = user["email"];
            } else {
                toSendUser["phone"] = parseInt(user["phone"]);
            }
            const result = await http.post("api/auth/login", toSendUser);
            if (isOtpEnabled && !result.data.is_logged_in) {
                let replacingPhone = "" + result.data.phone;
                replacingPhone = replacingPhone.padStart(11, 0);
                setUser({ ...user, phone: replacingPhone });
                setShowChangePhone(!(result.data.tokens_count > 0));

                // setisOtp(true);
                if (result.data.is_to_new_reset_password) {
                    setShowForgetPassword(true);
                    setIsConfirmedShowPasswordPhone(true);
                } else {
                    setisOtp(true);
                }
            } else {
                auth.authenticate(result.data.token, result.data.user);
                authUser({
                    ...result.data.user,
                });
                setIsLoading(false);
                modal.message({
                    title:
                        language === "en" ? "Logged in successfully!" : "تم تسجيل الدخول بنجاح !",
                    text: language === "en" ? "Click OK to continue" : "اضغط حسنًا للإستمرار",
                    callback: redirect,
                });
            }
        } catch ({ response }) {
            if (response.status === 455 && isAccountCreationRequest) {
                setAccountRequest(response.data.user);
                redirect("/account_creation_status");
            } else {
                handleFormErrors(response, setIsLoading, setErrors);
                if (response.status === 400 && response.data.error === "already_logged_in") {
                    setTokens(response.data.tokens);
                }
                if (response.status === 400 && response.data.error === "account_blocked") {
                    setIsBlocked(true);
                    setBlockageMessage(response.data.blockage_message);
                }
            }
        }
    };

    return (
        <div className={`negative-nav-margin gap-10 space-y-7 ${language !== "ar" ? "en" : ""}`}>
            <OtpComponent
                isOtp={isOtp}
                showChangePhone={showChangePhone}
                setShowChangePhone={setShowChangePhone}
                data={user}
                setData={setUser}
                errors={errors}
                setErrors={setErrors}
            />
            <ForgetPasswordComponent
                showForgetPassword={showForgetPassword}
                setShowForgetPassword={setShowForgetPassword}
                isConfirmedShowPasswordPhone={isConfirmedShowPasswordPhone}
                data={user}
                setData={setUser}
                errors={errors}
                setErrors={setErrors}
            />
            <SigningForm
                headTitle={content.title[language]}
                layout="Glassmorphism"
                headIcon={loginPageIcon}
                picture={loginPicture}
                description={content.description[language]}
                onSubmit={handleSubmit}
                fields={
                    <div className="space-y-12">
                        {inputFields.map((input, index) => {
                            return (
                                <InputField
                                    key={index}
                                    onChange={handleInputChange}
                                    data={user}
                                    setData={setUser}
                                    errors={errors}
                                    {...input}
                                />
                            );
                        })}
                    </div>
                }
                color={loginPageColor}
                secondaryColor={registerPageColor}
                buttonTitle={content.button.login[language]}
                isLoading={isLoading}
                altLink={"/register"}
                showForgetPassword={!user.with_code}
                handlePasswordForget={() => setShowForgetPassword(true)}
                alt={content.button.noAccount[language]}
                altColored={content.button.createAccount[language]}
                alternative={
                    tokens.length > 0 ? (
                        <div className="py-20 space-y-4">
                            <div className="rounded-md bg-rose-500 flex-center-both clr-white py-3">
                                انت مسجل دخولك بالفعل علي هذه الأجهزة!
                            </div>
                            <LoginDataTable data={tokens} isExcel={false} />
                            <div className="flex-center-both py-4">
                                يرجى تسجيل الخروج من هذه الأجهزة او التواصل مع الدعم
                            </div>
                        </div>
                    ) : isBlocked ? (
                        <div className="py-20 space-y-4">
                            <div className="rounded-md bg-rose-500 flex-center-both clr-white py-3">
                                تم حظر الحساب الخاص بك من الموقع !
                            </div>
                            <div className="flex-center-both py-4">
                                رقم الهاتف الخاص بك :{" "}
                                <span className="font-w-bold pr-1">{user.phone}</span>
                            </div>
                            <div className="rounded-md bg-yellow-500 flex-center-both clr-white py-3">
                                سبب الحظر :{" "}
                                <span className="font-w-bold pr-1">{blockageMessage}</span>
                            </div>
                            <div className="flex-center-both">
                                <Button color="rose" onClick={() => setIsBlocked(false)}>
                                    اعادة المحاولة
                                </Button>
                            </div>
                        </div>
                    ) : (
                        false
                    )
                }
            />
        </div>
    );
};

export default Login;
